import { Broker } from '@shared/types/custom/Broker'
import { CurrentOrganizationUser } from '@shared/types/custom/CurrentOrganizationUser'
import { Profile } from '@shared/types/custom/Profile'
import { createContext } from 'react'

type SessionContextType = {
  profile?: Profile
  broker?: Broker
  user?: CurrentOrganizationUser
  isAdmin: boolean
  removeUserData: () => void
  isLoading: boolean
  updateUserData: () => Promise<{
    user?: CurrentOrganizationUser
    broker?: Broker
  }> | null
}

const initialSessionContext: SessionContextType = {
  isAdmin: false,
  isLoading: false,
  updateUserData: () => null,
  removeUserData: () => null
}

export const UserSessionContext = createContext(initialSessionContext)
